/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
module.exports = require('./lib/router');



/*****************
 ** WEBPACK FOOTER
 ** ./~/routr/index.js
 ** module id = 26
 ** module chunks = 0
 **/